var _circle, _rect, _path, _rect2, _path2, _path3, _rect3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostSubmitted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.13,
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#9FBDF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 32.4395,
    width: 56.8462,
    height: 64.4616,
    rx: 7,
    fill: "#D4E4FF",
    stroke: "#313C4E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 89.5H60",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3086,
    y: 40.7471,
    width: 40.9231,
    height: 34,
    rx: 7,
    fill: "white",
    stroke: "#313C4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5335 70.1933C44.6223 67.9132 44.7101 65.1062 44.7123 62.8698C44.7133 61.8053 45.1066 60.7753 45.8407 60.0044L51.6169 53.9395L62.6938 64.3241L67.54 59.4779L82.7708 74.7087L48.5228 74.4002C46.2465 74.3797 44.4448 72.468 44.5335 70.1933Z",
    fill: "#C0EBE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 65V67C49 68.6569 50.3431 70 52 70H55",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.3086,
    y: 40.7471,
    width: 40.9231,
    height: 34,
    rx: 7,
    stroke: "#313C4E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1641 60.724L49.4619 55.6546C50.6538 54.5141 52.5429 54.5499 53.6907 55.7348L62.3469 64.6702L65.3731 61.644C66.562 60.4551 68.4958 60.4753 69.6596 61.6888L80.8186 73.324",
    stroke: "#313C4E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 50.5,
    r: 4.5,
    fill: "#FFE3BC",
    stroke: "#313C4E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3846,
    cy: 81.9779,
    r: 1.38462,
    fill: "#313C4E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9237,
    cy: 81.9779,
    r: 1.38462,
    fill: "#313C4E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4627,
    cy: 81.9779,
    r: 1.38462,
    fill: "#313C4E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1905,
    cy: 92.0164,
    r: 11.8077,
    fill: "white",
    stroke: "#313C4E",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1953 88.2087V95.8241",
    stroke: "#313C4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3828 91.6702H88.9982",
    stroke: "#313C4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostSubmitted);
export default __webpack_public_path__ + "static/media/post-submitted.902d5b115b914e24ef955aa1e3e4a837.svg";
export { ForwardRef as ReactComponent };